module.exports = __webpack_public_path__ + "static/img/award2_a.d523050.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/index/award2_a.png
// module id = 3BUx
// module chunks = 7